import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import Navbar from "./components/Navbar";
import CartDrawer from "./components/CartDrawer";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Menu from "./pages/Menu";
import OrderMenu from "./pages/OrderMenu";
import About from "./pages/About";
import FAQ from "./pages/FAQ";
import Order from "./pages/Order";
import Admin from "./pages/Admin";
import { Analytics } from "@vercel/analytics/react";
import Reviews from "./pages/Reviews";

export default function App() {
  return (
    <BrowserRouter>
      <CartProvider>
        <Routes>
          {/* Admin route — no navbar/footer */}
          <Route path="/admin" element={<Admin />} />

          {/* Public routes */}
          <Route path="/*" element={
            <div className="flex flex-col min-h-screen">
              <Navbar />
              <CartDrawer />
              <main className="flex-1">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/menu" element={<Menu />} />
                  <Route path="/order-now" element={<OrderMenu/>} />
                  <Route path="/faq" element={<FAQ />} />
                  <Route path="/order" element={<Order />} />
                  <Route path="/reviews" element={<Reviews />} />
                </Routes>
              </main>
              <Footer />
            </div>
          } />
        </Routes>
      </CartProvider>
      <Analytics />
    </BrowserRouter>
  );
}